export const Texts = {
    ALL_ITEM_CODE_OPTION: 'todos',
    ALL_ITEM_DESCRIPTION_OPTION: 'TODOS',
    NO_OPTION_DESCRIPTION: 'Nenhum'
}
